import React from 'react';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Icon from 'components/Icon';
import { Modal } from 'apps/modals/views/modal';
import { PlanChooser } from 'apps/components';
import { PricingAppManager } from 'apps/home/pricing/appManager';
import { modalStore } from 'apps/modals/app';

import styled from 'styled-components';

@withNamespaces()
@observer
export class PlanChooserModal extends Modal {
  @observable planMode = 'team';
  constructor(props) {
    super(props);
    this.size = 'large';
    this.projectAppManager = props.projectManager;

    this.pricingAppManager = new PricingAppManager(null, {
      ...props,
      onSuccess: this.onSuccess,
    });
  }

  onSuccess = () => {
    modalStore.ClearComponent();
    if (this.projectAppManager) {
      this.projectAppManager.NewProjectQuery();
    }
  };

  @computed
  get selectedIndividual() {
    return this.planMode === 'individual';
  }

  @action
  toggle = mode => {
    this.planMode = mode;
  };

  render() {
    return (
      <div className='w-full h-4/5 p-0'>
        <PlanChooser
          onClickSwitch={this.toggle}
          onClickIndividualFree={() => {
            modalStore.ClearComponent();
          }}
          onClickIndividualForKind={() => {
            // Start the free subscription on the profile space
          }}
          onClickCompanyForTeam={() => {
            // Start the free subscription on the Initiative? space
            // How does this make sense?
            // Because I will see this from anywhere
          }}
          onClickCompanyForBusiness={() => {}}
          selectedIndividual={this.selectedIndividual}
        />
      </div>
    );
  }
}
export const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.2em;
`;

export const StyledIcon = styled(Icon)`
  margin-right: 0.5em;
  transform: translateY(3px);
  width: 16px;
  height: 16px;
`;
